import React from 'react'
import {Icon} from '@chakra-ui/react'

const HmcIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M19.113 7.26861C19.5496 5.92503 21.4504 5.92504 21.887 7.26862L24.1016 14.0845C24.2968 14.6854 24.8567 15.0922 25.4885 15.0922L32.6552 15.0922C34.0679 15.0922 34.6553 16.9 33.5124 17.7304L27.7144 21.9428C27.2033 22.3142 26.9894 22.9724 27.1847 23.5733L29.3993 30.3892C29.8358 31.7328 28.2981 32.85 27.1551 32.0196L21.3572 27.8072C20.8461 27.4358 20.1539 27.4358 19.6428 27.8072L13.8449 32.0197C12.7019 32.85 11.1642 31.7328 11.6007 30.3892L13.8153 23.5733C14.0106 22.9724 13.7967 22.3142 13.2856 21.9428L7.48761 17.7303C6.34469 16.9 6.93208 15.0922 8.3448 15.0922L15.5115 15.0922C16.1433 15.0922 16.7032 14.6854 16.8984 14.0845L19.113 7.26861Z"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path
                d="M8 6.33337L11.5355 9.86891"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M33.2012 6.33337L29.6656 9.86891"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M36.5361 28.869L33.0006 25.3335"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M4 28.869L7.53553 25.3335"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default HmcIcon
